import React from 'react';
import {injectIntl, FormattedMessage, FormattedDate} from '@meiko/react-intl';
import {fullName} from 'utils/people';
import {marketingLeadStates} from 'dicts/leads';
import Table from 'components/generic/Table';
import Tr from 'components/generic/Tr';

const dateFmtOpts = {
	weekday: 'short',
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
};

const LeadEventsTable = ({events = [], slimRows = false}) => {
	return (
		<Table slimRows={slimRows}>
			<thead>
				<tr>
					<th>
						<FormattedMessage id="Status" />
					</th>
					<th>
						<FormattedMessage id="Date" />
					</th>
					<th>
						<FormattedMessage id="Comment" />
					</th>
					<th>
						<FormattedMessage id="User" />
					</th>
				</tr>
			</thead>
			<tbody>
				{events.map(e => (
					<Tr key={e.id}>
						<td>
							<FormattedMessage id={marketingLeadStates[e.state]} />
						</td>
						<td>
							<FormattedDate value={new Date(e.date)} {...dateFmtOpts} />
						</td>
						<td>{e.comment}</td>
						<td>{e.user ? fullName(e.user) : ''}</td>
					</Tr>
				))}
			</tbody>
		</Table>
	);
};

export default injectIntl(LeadEventsTable);
